var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-flex',{staticClass:"mb-3"},[_c('list',{attrs:{"hideCreate":"true"}})],1),_c('v-divider'),_c('invite')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }